import service from './service';
import { UrlBuilder } from './url-builder';

export const getPermissionList = async (companyId, userId, roleId) => {
  const builder = new UrlBuilder(`/companies/${companyId}/assign/${userId}`);
  builder.add('roleId', roleId);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return [];
};

export const assignPermissionToUser = async (companyId, userId, payload, roleId) => {
  try {
    const builder = new UrlBuilder(`/companies/${companyId}/permission/${userId}`);
    builder.add('roleId', roleId);
    const response = await service.post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const assignPermissionToUserAsDistributor = async (partnerId, userId, payload) => {
  try {
    const builder = new UrlBuilder(`/partners/${partnerId}/assign/${userId}`);
    const response = await service.post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
